import { useMemo } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import { WidgetCard } from "./WidgetCard";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

const ResponsiveGrid = WidthProvider(Responsive);

// Grid: 12 cols on desktop (lg), 4 cols on mobile (xs). Desktop & mobile
// layouts are stored & edited independently.
export function DashboardGrid({ layout, editing, onLayoutChange, onCollapse, onHide, onResize, onConfigure }) {
  const visible = useMemo(
    () => Object.entries(layout.widgets || {}).filter(([, w]) => !w.hidden).map(([id]) => id),
    [layout.widgets]
  );

  const layouts = useMemo(() => ({
    lg: (layout.desktop || []).filter((l) => visible.includes(l.i)),
    xs: (layout.mobile || []).filter((l) => visible.includes(l.i)),
  }), [layout.desktop, layout.mobile, visible]);

  return (
    <ResponsiveGrid
      className="nirvana-grid"
      layouts={layouts}
      breakpoints={{ lg: 1024, xs: 0 }}
      cols={{ lg: 12, xs: 4 }}
      rowHeight={64}
      margin={[20, 20]}
      containerPadding={[0, 0]}
      isDraggable={editing}
      isResizable={editing}
      draggableHandle=".widget-drag-handle"
      compactType="vertical"
      useCSSTransforms
      onLayoutChange={(_, all) => onLayoutChange(all)}
      data-testid="dashboard-grid"
    >
      {visible.map((id) => {
        const instance = layout.widgets[id];
        return (
          <div key={id}>
            <WidgetCard
              instanceId={id}
              instance={instance}
              editing={editing}
              onCollapse={() => onCollapse(id)}
              onHide={() => onHide(id)}
              onResize={(size) => onResize(id, size)}
              onConfigure={() => onConfigure(id)}
            />
          </div>
        );
      })}
    </ResponsiveGrid>
  );
}
